module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "card stack",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'stack',
          params: {
            slug: _vm.stack.slug
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "stack-actions"
  }, [(_vm.user) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.remove($event)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateStackModal($event)
      }
    }
  }, [_vm._v("edit")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "stack-title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'stack',
        params: {
          slug: _vm.stack.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.stack.title))])], 1), _vm._v(" "), _c('p', {
    staticClass: "stack-why"
  }, [_vm._v(_vm._s(_vm.stack.description))]), _vm._v(" "), _c('div', {
    staticClass: "stack-meta"
  }, [_c('p', [(_vm.stack.cards) ? _c('span', [_vm._v(_vm._s(_vm.cardNumber(_vm.stack.cards)))]) : _c('span', [_vm._v("0")]), _vm._v(" cards curated by " + _vm._s(_vm.stack.username))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c17f4a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/Stack.vue
// module id = 193
// module chunks = 1